<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
            <h4 class="alert-heading font-18 text-dark">Ընտրել հետաքրքող տենդերների կատեգորիաները</h4>
        </div>
        <div class="card-body">
          <!-- Nav tabs -->
          <!-- <ul class="nav nav-pills nav-justified" role="tablist">
            <li class="nav-item waves-effect waves-light">
              <a class="nav-link" @click.prevent="organizeType = 0" :class="{'active': organizeType === 0}"
                 data-toggle="tab" href="" role="tab" aria-selected="false">Պետական մրցույթներ</a>
            </li>
            <li class="nav-item waves-effect waves-light">
              <a class="nav-link" @click.prevent="organizeType = 1" :class="{'active': organizeType === 1}"
                 data-toggle="tab" href="" role="tab" aria-selected="false">Ոչ պետական մրցույթներ</a>
            </li>
          </ul> -->
          <!-- Tab panes -->
          <div v-if="loaded">
            <div class="tab-content">
              <div class="tab-panel" :class="{'active': organizeType === 0}" id="settings-1" role="tabpanel">
                <div class="row">
                  <div class="col-12">
                    <StateCategory :selectedCpvs.sync="selectedCpvs" />
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="tab-content">
              <div class="tab-pane pt-3 mt-2" :class="{'active': organizeType === 1}" id="settings-2" role="tabpanel">
                <div class="row">
                  <div class="col-12">
                  <Category :selectedCategories.sync="selectedCategories" />
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="text-center" v-else>
            <div class="m-3 spinner-border spinner-border-xl text-primary" role="status"></div>
          </div>
          <div id="modal-footer" class="bg-white w-100 mt-2 pr-0 text-right" style="bottom: 0">
            <button @click="$router.push(`/participant/tenders`);" type="button" class="btn btn-primary mr-3">
              Դիտել համապատասխանող տենդերները
            </button>
            <button @click="handleClick" type="button" class="btn btn-primary">
              Պահպանել
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StateCategory from "./categoryForm/StateCategory";

  export default {
    components: { StateCategory },
    name: 'selectCategory',
    data() {
      return {
        organizeType: 0,
        selectedCpvs: [],
        selectedCategories: [],
        update: false,
        loaded: false,
      }
    },
    async mounted() {
      await this.$client.get('user-cpvs').then(({data}) => {
        if(data.data.length){
          this.selectedCpvs = [...data.data]
          this.update = true;
        } else if(this.$route.path !== '/settings') {
          this.$fire({
            title: "Զգուշացում",
            text: "Խնդրում ենք ընտրել կատեգորիա շարունակելու համար",
            type: "warning",
            confirmButtonText: 'Լավ'
          })
        }
        this.$client.get('user-categories').then(({data}) => {
          if(data.data){
            this.selectedCategories = [...data.data]
          }
        })
      })
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
      this.$store.dispatch('procurement/getPlans')
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
    },
    methods: {
      handleClick() {
        if (!this.selectedCpvs.length && !this.selectedCategories.length) {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Ընտրեք գոնե մեկ կատեգորիա շարունակելու համար'
          })
        } else {
          this.$client.post(`user-cpvs/${this.me.id}`, this.selectedCpvs).then(({data}) => {
            if(data.status){
              this.$client.post(`user-categories/${this.me.id}`, this.selectedCategories).then(({data}) => {
                console.log(data)
                if(data.status){
                  this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'Հաջողությամբ պահպանված է'
                  })
                  this.$client.put(`user`, { first_login: 0 }).then(({data}) => {
                    if(data){
                      this.$store.dispatch('firstLogin', 0).then(() => {
                        this.$router.push({ path: '/participant/tenders' })
                      })
                    }
                  }).catch(e => {
                    this.$notify({
                      group: 'foo',
                      type: 'error',
                      title: 'Ինչ որ բան այն չէ',
                      text: 'Կրկին փորձեք!'
                    })
                  })
                }
              }).catch(e => {
                this.$notify({
                  group: 'foo',
                  type: 'error',
                  title: 'Ինչ որ բան այն չէ',
                  text: 'Կրկին փորձեք!'
                })
              })
            }
          }).catch(e => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
          })
        }
      },
    },
  }
</script>
